/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const BidRuleIcon = ({ width = 24, height = 24, hidden = false, title = 'Bid Rule' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="m18 12 6-6 5.999 6-6 6z" />
    <rect
      height="3.155"
      rx=".789"
      ry=".789"
      transform="rotate(-44.995 30.008 18.01)"
      width="12.619"
      x="23.7"
      y="16.432"
    />
    <rect
      height="3.155"
      rx=".789"
      ry=".789"
      transform="rotate(-44.995 18.023 6.023)"
      width="12.619"
      x="11.713"
      y="4.445"
    />
    <path
      d="m4.06 34.06-2.12-2.12a1.5 1.5 0 0 1 0-2.122L18 15l3 3L6.182 34.06a1.5 1.5 0 0 1-2.122 0ZM34 30v-1a1 1 0 0 0-1-1H23a1 1 0 0 0-1 1v1h-1.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5Z"
    />
  </svg>`;
};
